import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
import { CheckIcon, LockIcon, DownloadIcon, RotateCcwIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout13.rosetadigital.com/cart/48216724078812:1';
export function PricingSection() {
  const {
    ref,
    isInView
  } = useInView();
  const goToCheckout = () => {
    const pixelId = '1434214195167085';
    const contentName = 'CONTROLA LA ANSIEDAD — Pack Completo Base';
    const contentId = 'ANSIEDAD_BASE_001';
    const value = 19990;
    const w = window as any;
    if (typeof w.fbq === 'function') {
      w.fbq('track', 'InitiateCheckout', {
        content_name: contentName,
        content_ids: [contentId],
        value: value,
        currency: 'ARS'
      });
    }
    const img = new Image(1, 1);
    const params = new URLSearchParams({
      id: pixelId,
      ev: 'InitiateCheckout',
      noscript: '1',
      'cd[content_name]': contentName,
      'cd[value]': String(value),
      'cd[currency]': 'ARS'
    });
    img.src = `https://www.facebook.com/tr?${params.toString()}`;
    setTimeout(() => {
      window.location.href = CHECKOUT_URL;
    }, 300);
  };
  return <section className="py-14 px-4 bg-primary" id="pricing" ref={ref} data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10" data-id="element-117">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-118">
            Elegí tu pack
          </h2>
          <p className="text-text-secondary text-lg sm:text-xl" data-id="element-119">
            Acceso inmediato y los 6 bonus gratis incluidos
          </p>
        </motion.div>

        <div className="bg-white border border-gray-200 shadow-sm rounded-xl py-3 px-6 flex items-center justify-center gap-3 max-w-xs mx-auto mb-8" data-id="element-120">
          <span className="text-gray-700 text-sm font-semibold whitespace-nowrap" data-id="element-121">
            Pago seguro con
          </span>
          <img src="https://cdn.magicpatterns.com/uploads/mMvN5T9AhW2v7rtXaCYNWs/pasted-image.png" alt="Mercado Pago" className="h-8 w-auto" data-id="element-122" />
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-card border-2 border-accent-gold rounded-2xl p-6 sm:p-8 max-w-lg mx-auto relative shadow-xl" data-id="element-123">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-accent-gold text-white px-6 py-1.5 rounded-full font-bold text-sm whitespace-nowrap shadow-sm" data-id="element-124">
            ⭐ MÁS ELEGIDO
          </div>

          <h3 className="text-3xl font-bold text-slate-900 mb-2 text-center mt-2" data-id="element-125">
            Pack Completo
          </h3>
          <p className="text-text-secondary text-base text-center mb-6" data-id="element-126">
            6 Volúmenes + 6 Bonus Gratis
          </p>

          <ul className="space-y-3 mb-6" data-id="element-127">
            {['6 Volúmenes PDF (360 páginas)', '6 Bonus PDF (90 páginas)', 'Envío inmediato por email en PDF', 'De por vida — sin vencimiento'].map((item, i) => <li key={i} className="flex items-start" data-id="element-128">
                <CheckIcon className="w-6 h-6 text-amber-500 mr-3 shrink-0" data-id="element-129" />
                <span className="text-slate-800 font-medium text-lg" data-id="element-130">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="text-center mb-4" data-id="element-131">
            <span className="text-text-secondary line-through text-xl block mb-1" data-id="element-132">
              $39.990
            </span>
            <span className="text-slate-900 font-bold text-5xl sm:text-6xl block mb-2" data-id="element-133">
              $19.990
            </span>
            <span className="text-accent-gold text-sm font-bold tracking-wider uppercase" data-id="element-134">
              ARS · Pago único
            </span>
          </div>

          <div className="flex items-center justify-center gap-2 mb-4 text-sm" data-id="element-135">
            <span className="relative flex h-2.5 w-2.5" data-id="element-136">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-gold opacity-75" data-id="element-137"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-gold" data-id="element-138"></span>
            </span>
            <span className="text-text-secondary" data-id="element-139">
              <span className="text-slate-900 font-semibold" data-id="element-140">23 personas</span>{' '}
              compraron en las últimas 24hs
            </span>
          </div>

          <button onClick={goToCheckout} className="w-full bg-accent-gold text-white font-bold text-xl py-5 px-8 rounded-xl hover:scale-[1.03] transition-transform duration-300 glow-gold flex items-center justify-center mb-4" data-id="element-141">
            SÍ, QUIERO CONTROLAR MI ANSIEDAD →
          </button>

          <div className="bg-gray-50 rounded-lg p-3 mb-4 border border-gray-100" data-id="element-142">
            <p className="text-slate-700 text-sm italic text-center leading-relaxed" data-id="element-143">
              "Llevaba 3 años con ataques de pánico. Después de leer el Volumen
              2 tuve mi primera semana sin ninguno."
            </p>
            <p className="text-accent-gold text-xs text-center mt-1.5 font-bold" data-id="element-144">
              — Valentina M., Buenos Aires ⭐⭐⭐⭐⭐
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-xl py-3 px-6 flex items-center justify-center gap-3" data-id="element-145">
            <span className="text-gray-700 text-sm font-semibold whitespace-nowrap" data-id="element-146">
              Pago seguro con
            </span>
            <img src="https://cdn.magicpatterns.com/uploads/mMvN5T9AhW2v7rtXaCYNWs/pasted-image.png" alt="Mercado Pago" className="h-8 w-auto" data-id="element-147" />
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mt-4 text-text-secondary text-sm" data-id="element-148">
            <div className="flex items-center" data-id="element-149">
              <LockIcon className="w-4 h-4 text-accent-gold mr-2" data-id="element-150" /> Pago Seguro
              SSL
            </div>
            <div className="flex items-center" data-id="element-151">
              <DownloadIcon className="w-4 h-4 text-accent-gold mr-2" data-id="element-152" /> PDF
              Inmediato
            </div>
            <div className="flex items-center" data-id="element-153">
              <RotateCcwIcon className="w-4 h-4 text-accent-gold mr-2" data-id="element-154" />{' '}
              Garantía 7 días
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}